import { Component, Signal, inject } from '@angular/core';
import { AccessListDetails, AppShieldAccessListsThreatItemComponent, PlanType, ShieldAccessListsApiStore, ShieldAccessListsStoreType } from '@bn/app-shield';
import { AppShieldActionPrecedenceComponent } from '@bn/app-shield/pages/app-shield-access-lists/components/app-shield-action-precedence-component/app-shield-action-precedence-component';
import { StoreRequest } from '@bn/shared/state-store';
import { BadgeComponent } from '@bn/web-ui/badge/badge.component';
import { CardComponent } from '@bn/web-ui/card/card.component';

@Component({
  templateUrl: './app-shield-access-lists-curated-threat-lists.page.html',
  styleUrls: ['./app-shield-access-lists-curated-threat-lists.page.scss'],
  imports: [BadgeComponent, CardComponent, AppShieldAccessListsThreatItemComponent, AppShieldActionPrecedenceComponent],
})
export class AppShieldAccessListsCuratedThreatListsPage {
  readonly #shieldAccessListsStore = inject(ShieldAccessListsApiStore);

  protected readonly PlanType = PlanType;

  readonly isLoading = this.#shieldAccessListsStore.isLoading(StoreRequest.List);
  readonly storeManagedList = this.#shieldAccessListsStore.managedLists as Signal<ShieldAccessListsStoreType['managedLists']>;

  public groupedManagedLists(): { plan: number; items: any[] }[] {
    const list = this.storeManagedList?.() ?? [];
    const byPlan = new Map<number, AccessListDetails[]>();

    for (const item of list) {
      const plan = item?.requiredPlan ?? 0;
      if (!byPlan.has(plan)) byPlan.set(plan, []);
      byPlan.get(plan)?.push(item);
    }

    return Array.from(byPlan.entries())
      .sort((a, b) => a[0] - b[0])
      .map(([plan, items]) => ({ plan, items }));
  }
}
